module.exports = __webpack_public_path__ + "media/landing/top-right-wave-13d256d5.png";